import { Col, Row } from "antd";
import { useCDNFileContext } from "../../../context/CDNFileContext/CDNFileContext";
import InputComponent from "../../../components/InputComponent";


const Info = () => {
	const { cdnFileData, setCDNFileData } = useCDNFileContext();

	return (
		<>
			<Row gutter={20}>
				<Col span={20}>
					<InputComponent
						title={"Dosya Adı"}
						placeholder="CDN Dosya Adı"
						value={cdnFileData?.name}
						isRequired
						onChange={(e) => setCDNFileData({ ...cdnFileData, name: e.target.value })}
					/>
				</Col>
			</Row >
		</>
	);
};

export default Info;
